import { Component, Input, Optional, SkipSelf, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ComponentsModule } from '@components/components.module';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'tk-agreement',
	standalone: true,
	templateUrl: './agreement.component.html',
	styleUrl: './agreement.component.sass',
	imports: [RouterLink, ComponentsModule],
	viewProviders: [
		{
			provide: ControlContainer,
			useFactory: (container: ControlContainer) => container,
			deps: [[new Optional(), new SkipSelf(), ControlContainer]]
		}
	]
})
export class AgreementComponent implements OnInit, OnDestroy {
	@Input() buttonLabel = 'Отправить';
	@Input() theme: 'black' | 'white' = 'black';
	@Input() controlName = 'agreement';
	
	private destroy$ = new Subject<void>();
	isInvalid = false;

	agreementCheckboxId = 'agreement-' + Math.random().toString(36).substring(2, 11);
	
	constructor(
		private controlContainer: ControlContainer,
		@Optional() private formGroupDirective: FormGroupDirective
	) {
		if (this.formGroupDirective) {
			this.formGroupDirective.ngSubmit
				.pipe(takeUntil(this.destroy$))
				.subscribe(() => {
					this.markControlAsTouchedAndUpdate();
				});
		}
	}
	
	ngOnInit() {
		const control = this.control;
		if (control) {
			control.valueChanges
				.pipe(takeUntil(this.destroy$))
				.subscribe(() => {
					this.updateInvalidState();
				});
		}
	}
	
	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
	
	get control() {
		return this.controlContainer?.control?.get(this.controlName);
	}
	
	private markControlAsTouchedAndUpdate() {
		const control = this.control;
		if (control) {
			control.markAsTouched();
			this.updateInvalidState();
		}
	}
	
	private updateInvalidState() {
		const control = this.control;
		if (control) {
			this.isInvalid = control.invalid && control.touched;
		}
	}
}
